/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S7_P1Inputs */

const tr_onbilgi_s7_p1 = /** @type {(inputs: Onbilgi_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6502 sayılı Tüketicinin Korunması Hakkında Kanun Madde 48 ve Mesafeli Sözleşmeler Yönetmeliği uyarınca, tüketici sıfatını haiz Müşteri sözleşmenin kurulduğu tarihten itibaren 14 (on dört) gün içinde herhangi bir gerekçe göstermeksizin cayma hakkını kullanabilir.`)
};

const en_onbilgi_s7_p1 = /** @type {(inputs: Onbilgi_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pursuant to 6502 sayılı Tüketicinin Korunması Hakkında Kanun Madde 48 and the Mesafeli Sözleşmeler Yönetmeliği, a Customer who holds consumer status may exercise the right of withdrawal within 14 (fourteen) days from the date the contract was concluded, without giving any reason.`)
};

const de_onbilgi_s7_p1 = /** @type {(inputs: Onbilgi_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemäß 6502 sayılı Tüketicinin Korunması Hakkında Kanun Madde 48 und der Mesafeli Sözleşmeler Yönetmeliği kann der Kunde, der Verbraucher ist, innerhalb von 14 (vierzehn) Tagen ab dem Tag des Zustandekommens des Vertrages ohne Angabe von Gründen sein Widerrufsrecht ausüben.`)
};

const ru_onbilgi_s7_p1 = /** @type {(inputs: Onbilgi_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В соответствии с 6502 sayılı Tüketicinin Korunması Hakkında Kanun Madde 48 и Mesafeli Sözleşmeler Yönetmeliği Клиент, обладающий статусом потребителя, может воспользоваться правом на отказ от договора в течение 14 (четырнадцати) дней с даты заключения договора без указания причин.`)
};

/**
* | output |
* | --- |
* | "Pursuant to 6502 sayılı Tüketicinin Korunması Hakkında Kanun Madde 48 and the Mesafeli Sözleşmeler Yönetmeliği, a Customer who holds consumer status may exer..." |
*
* @param {Onbilgi_S7_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s7_p1 = /** @type {((inputs?: Onbilgi_S7_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S7_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s7_p1(inputs)
	if (locale === "de") return de_onbilgi_s7_p1(inputs)
	if (locale === "ru") return ru_onbilgi_s7_p1(inputs)
	return tr_onbilgi_s7_p1(inputs)
});